module.exports = __webpack_public_path__ + "static/img/login-background.446c1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/APRILYOS/login-background.png
// module id = hVrt
// module chunks = 0